$shm_hitalama_projects $shm_projects_catalog
	team null $shm_hitalama_team
	pinned_map null $shm_hitalama_map
	records_for_map /$shm_projects_data_record
	projects_map_id? \
	projects_map_ensure \
	projects_link_open? null
	maps $shm_hitalama_map_catalog
	Help $shm_hitalama_guide_toggle
		section \projects
	Projects_menu $mol_list
		rows <= projects_menu_rows /
	Pinned_map_book $shm_hitalama_map_book
	Map_slot $shm_hitalama_projects_map
		projects <= self $shm_hitalama_projects
